<template>
  <div class="escenario">
    <escenario-horizontal :escenario="escenario" v-if="escenario && escenario.tipoSolucion === 'obra_nueva_horizontal'">
    </escenario-horizontal>
    <escenario-vertical :escenario="escenario" v-if="escenario && escenario.tipoSolucion === 'obra_nueva_vertical'">
    </escenario-vertical>
    <escenario-fachada :escenario="escenario" v-if="escenario && escenario.tipoSolucion === 'obra_nueva_fachada'">
    </escenario-fachada>
    <escenario-urbano :escenario="escenario" v-if="escenario && escenario.tipoSolucion === 'obra_nueva_urbano'">
    </escenario-urbano>
    <escenario-horizontal-r v-if="escenario && escenario.tipoSolucion === 'horizontal_rehabilitation'"
                            :escenario="escenario">
    </escenario-horizontal-r>
    <escenario-vertical-r v-if="escenario && escenario.tipoSolucion === 'vertical_rehabilitation'"
                          :escenario="escenario">
    </escenario-vertical-r>
    <escenario-fachada-r v-if="escenario && escenario.tipoSolucion === 'facade_rehabilitation'"
                         :escenario="escenario">
    </escenario-fachada-r>
    <escenario-exterior v-if="escenario && escenario.tipoSolucion === 'obra_nueva_exterior'" :escenario="escenario"/>
    <escenario-exterior-r v-if="escenario && escenario.tipoSolucion === 'rehabilitacion_exterior'"
                          :escenario="escenario"/>
  </div>
</template>

<script>
import EscenarioHorizontal from "./EscenariosTipos/EscenarioHorizontal";
import EscenarioVertical from "./EscenariosTipos/EscenarioVertical";
import EscenarioFachada from "./EscenariosTipos/EscenarioFachada";
import EscenarioUrbano from "./EscenariosTipos/EscenarioUrbano";
import EscenarioHorizontalR from "./EscenariosTipos/EscenarioHorizontalR";
import EscenarioVerticalR from "./EscenariosTipos/EscenarioVerticalR";
import EscenarioFachadaR from "./EscenariosTipos/EscenarioFachadaR";
import EscenarioExterior from "./EscenariosTipos/EscenarioExterior";
import EscenarioExteriorR from "./EscenariosTipos/EscenarioExteriorR";

export default {
  name: "EscenarioImpresion",
  props: {
    escenario: {type: Object, required: true}
  },
  components: {
    EscenarioHorizontal,
    EscenarioVertical,
    EscenarioFachada,
    EscenarioUrbano,
    EscenarioHorizontalR,
    EscenarioVerticalR,
    EscenarioFachadaR,
    EscenarioExterior,
    EscenarioExteriorR
  }
}
</script>

<style lang="scss">
.escenario {
  font-size: 14px !important;

  .col-12 {
    padding: 0px 10px !important;
    margin-left: 2px;
  }
}
</style>